module.exports = __webpack_public_path__ + "static/media/timesheets.493ad43b.webp";